<button 
    *ngIf = "caseRequirement?.hasAgentCommunication || false"
    mat-menu-item (click)="handleMenuAction()">
    <span>Add Agent Communication</span>
</button>